export default __webpack_public_path__ + "static/images/minigame-spotlight.png";